export function backfillString(initialStr: string, fillStr: string): string {
	if (initialStr.length < fillStr.length) {
		const appendStr = fillStr.slice(initialStr.length - fillStr.length);
		return `${initialStr}${appendStr}`;
	}

	return initialStr;
}
